import { TipoParametroChoiceEnum } from "@/shared/constants"

export interface IDataBitacoraResp {
  code: number
  status: string
  message: string
  data: IBitacora
}

export interface IDataBitacoraRespById {
  code: number
  status: string
  message: string
  data: Venta
}

export interface IBitacora {
  count: number,
  numeros_paginas: number | undefined;
  currentPage: number
  data: Venta[];
}

export interface Venta {
  _id: string
  numero_referencia_venta: string
  estado_venta: string
  estado_bitacora: string
  identificacion_cliente: string
  nombre_cliente: string
  canal_venta: string
  vendedor: string
  diccionario_motivo: DiccionarioMotivo[]
  leido: boolean
  contado: number
  createdAt: string
  updatedAt: string
  __v: number
}

export interface DiccionarioMotivo {
  _id: string
  estado_diccionario_motivo: string
  creado_por: string
  fase_venta: string
  motivos: Motivo[]
  createdAt: string
  updatedAt: string
  __v: number
}

export interface Motivo {
  _id: string
  numero_referencia_motivo: string
  descripcion: string
  estado_motivo: string
  prioridad: string
  comentarios: Comentario[]
  createdAt: string
  updatedAt: string
  __v: number
}

export interface Comentario {
  _id: string
  comentario: string
  leido: boolean
  username: string
  rol: string
  departamento: string
  tipo: TipoParametroChoiceEnum
  visto_por: VistoPor[] | null
  visto_por_tipo: string
  createdAt: string
  updatedAt: string
  __v: number
}

export interface VistoPor {
  username: string, rol: string
}


export interface InformacionUsuarioSocket {
  username: string
  departamento: string
  nombre: string
  rol: string
  socket_id: string
}


export enum EstadoBitacoraEnum {
  FINALIZADO = 'FINALIZADO',
  EN_PROCESO = 'EN PROCESO',
  CANCELADO = 'CANCELADO'
}

export enum EstadoDiccionarioMotivoEnum {
  FINALIZADO = 'FINALIZADO',
  EN_PROCESO = 'EN PROCESO'
}

export enum EstadoMotivoEnum {
  RESUELTO = 'RESUELTO',
  NO_RESUELTO = 'NO RESUELTO'
}